import {
  CALCULATION_SUCCESS,
  FETCH_START,
  FETCH_END,
} from '../../actions/SalesCommission/ActionTypes';
const initialState = {
  loading: false,
  calculationResult: [],
};

const SalesCommissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case CALCULATION_SUCCESS:
      return {
        ...state,
        calculationResult: action.data,
        loading: false,
      };
    case FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default SalesCommissionReducer;
